import { Icon } from './icon'

class MultiSubmission {
  init(e) {
    this.handleInputChanges()
    this.compareAllValues(e)
    this.nigoCheck()
  }

  nigoCheck() {
    const chipContainers = Array.from(document.querySelectorAll('.chip-container'))

    chipContainers.forEach(container => {
      const chip = container.querySelector('span')
      const recordContainer = chip.closest('.submission')
      const isCurrentIdentityReviewer = Boolean(recordContainer.dataset.isCurrentIdentityReviewer === 'true')

      if (isCurrentIdentityReviewer && chip.classList.contains('nigo-chip')) {
        const chip = this.buildChip()
        const arrow = this.arrowForwardIcon

        chip.classList.add(
          'bg-yellow-500/10',
          'border',
          'border-yellow-500',
          'flex',
          'items-center',
          'justify-center',
          'chip',
        )
        chip.innerHTML = 'Pending'

        container.appendChild(arrow)
        container.appendChild(chip)
      }
    })
  }

  handleInputChanges() {
    const inputs = document.querySelectorAll('.record-field')

    inputs.forEach(input => {
      if (input.type === 'select-one') {
        input.addEventListener('change', e => {
          this.compareValues(e)
        })
      } else {
        input.addEventListener('input', e => {
          this.compareValues(e)
        })
      }
    })
  }

  compareAllValues(e) {
    const records = Array.from(e.querySelectorAll('.new-business-record'))

    records.forEach(record => {
      const inputs = Array.from(record.querySelectorAll('.record-item'))

      this.highlightChangedLabels(record, inputs)
    })
  }

  compareValues(e) {
    const inputs = Array.from(e.target.closest('.record-body').querySelectorAll('.record-item'))

    this.highlightChangedLabels(e.target, inputs)
  }

  highlightChangedLabels(arg, values) {
    const nonmatchingRecords = []

    values.forEach(input => {
      const initialValue = input.querySelector('.stored-record-data').innerHTML
      const label = input.querySelector('label')
      const inputField = input.querySelector('.record-field')

      if (!inputField) return

      const currentValue = inputField.value.replaceAll(',', '')

      if (initialValue !== currentValue) {
        nonmatchingRecords.push(currentValue)

        label.classList.add('has-updates')
      } else {
        label.classList.remove('has-updates')
      }
    })

    nonmatchingRecords.length === 0 ? this.removePending(arg) : this.createPending(arg)
  }

  createPending(target) {
    const arrow = this.arrowForwardIcon
    const chip = this.buildChip()
    const chipContainer = target.closest('.new-business-record')?.querySelector('.chip-container')

    if (!chipContainer) return

    const existingArrow = chipContainer.querySelector('.arrow')
    const existingChip = chipContainer.querySelector('.chip')

    chip.classList.add(
      'bg-yellow-500/10',
      'border',
      'border-yellow-500',
      'flex',
      'items-center',
      'justify-center',
      'chip',
    )
    chip.innerHTML = 'Pending'

    if (!existingArrow) chipContainer.appendChild(arrow)
    if (!existingChip) chipContainer.appendChild(chip)
  }

  removePending(target) {
    const chipContainer = target.closest('.new-business-record')?.querySelector('.chip-container')

    if (!chipContainer) return

    const existingArrow = chipContainer.querySelector('.arrow')
    const existingChip = chipContainer.querySelector('.chip')

    existingChip?.remove()
    existingArrow?.remove()
  }

  observeRecordDataChanges() {
    const records = Array.from(document.querySelectorAll('.new-business-record'))

    records.forEach(record => {
      record.addEventListener('change', e => {
        this.compareValues(e)
      })
    })
  }

  storeInitialStatus() {
    const records = Array.from(document.querySelectorAll('.new-business-record'))

    records.forEach(record => {
      const hiddenStatus = record.querySelector('.hidden-status')?.value

      // If the hidden-status input doesn't exist, we don't need to store anything
      if (!hiddenStatus) return

      const text = document.createElement('p')

      text.classList.add('stored-status', 'hidden')
      text.innerHTML = hiddenStatus

      record.appendChild(text)
    })
  }

  get arrowForwardIcon() {
    return new Icon('icon-arrow-forward', { classes: 'arrow mx-1.5 text-gray-400' }).asElement()
  }

  buildChip() {
    const chip = document.createElement('span')
    const classes = ['text-gray-700', 'px-3', 'py-1', 'text-tiny', 'rounded-md', 'font-semibold', 'chip', 'border']

    chip.classList.add(...classes)

    return chip
  }

  handleGlobalUndo(el) {
    el.addEventListener('click', e => {
      const container = e.target.closest('.multi-select-container')
      const checkedCheckboxes = Array.from(container.querySelectorAll('input[type="checkbox"]:checked'))

      checkedCheckboxes.forEach(box => {
        const item = box.closest('.multi-select-item')
        const storedStatus = box.closest('.new-business-record').querySelector('.stored-status').innerHTML
        const hiddenStatus = item.querySelector('.hidden-status')

        hiddenStatus.value = storedStatus
      })
    })
  }
}

export default MultiSubmission
